var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-content[data-v-2bbb31e8]{width:100%;max-width:1200px}.body1[data-v-2bbb31e8]{height:1230px;padding-top:490px;display:flex;justify-content:center;box-sizing:border-box;background:url(" + escape(require("../../assets/about-us-banner.png")) + ") no-repeat top;background-size:100% auto}.body1 .content[data-v-2bbb31e8]{width:100%;max-width:1200px;height:630px;background:#fff;border-radius:25px;box-sizing:border-box;padding:48px 80px 34px}.body1 .content .tit-p[data-v-2bbb31e8]{width:100%;text-align:center;color:#000;font-size:24px;font-weight:700;margin-bottom:20px}.body1 .content .des-p[data-v-2bbb31e8]{width:100%;font-size:18px;text-align:left;line-height:32px;color:#2f2f2f;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bbb31e8","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/about-us/e-body1.vue
// module id = 195
// module chunks = 0